<template>
  <NetworkStatus v-if="isOffline" />
  <div>
    <Studentcount v-if="showStudentCountModal" @close="showStudentCountModal = false" />
    <div class="modal fade" id="editStudentCountModal" tabindex="-1">
      <div class="modal-dialog  ms-auto">
        <div class="card">
          <div class="modal-content">
            <div class="modal-header border-0">
              <button
                type="button"
                class="btn-close"
                @click="closeStudentCountModal"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body mt-n3 text-left pb-4">
              <div class="text-center mb-4">
                <i
                  class="bi bi-exclamation-triangle-fill text-warning fs-2 mb-3"
                ></i>
                <h6>{{ $t("params.add_student_title1") }}</h6>
              </div>

              <div class="form-group w-80 mx-auto">
                <label
                  style="font-size: 15px; transform: translateY(10px)"
                  for="studentCount"
                  class="form-label"
                  >{{ $t("params.student_count") }}
                  <span class="text-danger">*</span>
                </label>
                <label for="studentCount" class="form-label">{{$t("new_class.description") }}</label>
                <input
                  type="number"
                  class="form-control"
                  required
                  id="studentCount"
                  v-model="editedStudentCount"
                  min="1"
                  style="height: 45px"
                  placeholder="Ex: 10000"
                />
              </div>
            </div>

            <div class="modal-footer border-0 pb-5 mb-1">
              <argon-button
                type="button"
                class="btn bg-transparent"
                @click="closeStudentCountModal"
                data-bs-dismiss="modal"
                style="
                  width: 150px;
                  height: 50px;
                  padding-top: 15px;
                  border: 1px solid rgba(255, 255, 255, 0.4);
                "
              >
                {{ $t("button.cancel") }}
              </argon-button>
              <argon-button
                :loading="loading"
                :active="buttonActive || showConfirmation"
                :disabled="!editedStudentCount || editedStudentCount < 1"
                color="success"
                variant="gradient"
                type="button"
                class="mt-1"
                style="width: 150px; height: 50px; padding-top: 15px ; margin-right: 106px;"
                @click="saveStudentCount">
                <span v-if="!loading">{{ $t("button.save") }}</span>
              </argon-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal pour modifier le nom de l'école -->
    <div class="modal fade" id="editSchoolNameModal" tabindex="-1">
      <div class="modal-dialog ms-auto">
        <div class="card">
          <div class="modal-content">
            <div class="modal-header border-0">
              <button
                type="button"
                class="btn-close"
                @click="closeEditNameModal"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div class="modal-body mt-n3 text-left pb-4">
              <div class="text-center mb-4">
                <i
                  class="bi bi-exclamation-triangle-fill text-warning fs-2 mb-3"
                ></i>
                <h6>{{ $t("params.edit_school_name") }}</h6>
              </div>
              <div class="form-group w-80 mx-auto">
                <label for="schoolName" class="form-label">{{
                  $t("params.school_name")
                }}</label>
                <input
                  style="height: 45px"
                  type="text"
                  class="form-control"
                  required
                  id="schoolName"
                  v-model="editedSchoolName"
                  :placeholder="$t('params.enter_school_name')"
                />
              </div>
            </div>

            <div class="modal-footer border-0 mb-1 pb-5">
              <argon-button
                type="button"
                class="btn bg-transparent"
                @click="closeEditNameModal"
                data-bs-dismiss="modal"
                aria-label="Close"
                style="
                  width: 150px;
                  height: 50px;
                  padding-top: 15px;
                  border: 1px solid rgba(255, 255, 255, 0.4);
                "
              >
                {{ $t("button.cancel") }}
              </argon-button>
              <argon-button
                :loading="loading"
                :active="buttonActive || showConfirmation"
                :disabled="!editedSchoolName || editedSchoolName === name"
                :clickEvent="button"
                color="success"
                variant="gradient"
                type="button"
                class="mt-1"
                style="width: 150px; height: 50px; padding-top: 15px; margin-right: 106px;"
                @click="saveSchoolName"
              >
                <span v-if="!loading"> {{ $t("button.save") }}</span>
              </argon-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container top-0 position-sticky z-index-sticky"></div>

    <main class="main-content mt-0">
      <div
        class="page-header align-items-start min-vh-50 pt-5 pb-11 m-3 border-radius-lg"
        style="background-image: url('https://cdn.pixabay.com/photo/2015/07/19/10/00/school-work-851328_640.jpg');">
        <span class="mask bg-gradient-dark opacity-6"></span>
        <div class="container">
          <div class="row justify-content-center">
            <spinner class="text-center" v-if="loading" style="height: 200px">
              <div>
                <span class="mt-4">
                  <Spinner></Spinner>
                </span>
              </div>
            </spinner>

            <div class="col-lg-5 mt-8 text-center mx-auto" v-else>
              <h3 class="text-white mb-2 mt-3">
                {{ $t("params.params") }}{{ schoolInfo.name }}
              </h3>

              <div class="button mt-4 mb-4">
                <span
                  @click="saveConfig"
                  title="Aller la page d'accueil"
                  class="opacity-6 heart-animation"
                  :loading="loading"
                  :active="buttonActive || showConfirmation"
                >
                  {{ $t("button.continue") }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row mt-md-n11 mt-n10 justify-content-center">
          <div class="col-xl-10 col-lg-10 col-md-10 mx-auto">
            <div class="card z-index-0">
              <div class="card-body">
                <spinner
                  class="text-center mt-8 mb-8"
                  v-if="loading"
                  style="height: 200px"
                >
                  <div>
                    <span class="mt-4">
                      <Spinner></Spinner>
                    </span>
                  </div>
                </spinner>

                <form role="form" v-else>
                  <div class="image text-center mx-auto mb-5">
                    <div class="mx-auto upload-container">
                      <input
                        type="file"
                        id="logoUpload"
                        @change="onFileChange"
                        accept="image/*"
                        class="file-input"
                      />
                      <label for="logoUpload" class="upload-label">
                        <img
                          v-if="previewImage"
                          :src="previewImage"
                          :alt="$t('params.logo_preview')"
                          class="preview-image"
                        />
                        <img
                          v-else-if="schoolLogo"
                          :src="schoolLogo"
                          :alt="$t('params.school_logo')"
                          class="preview-image"
                        />
                        <span
                          v-else
                          class="upload-icon bi bi-file-image"
                        ></span>
                        <span class="upload-text">{{
                          schoolLogo
                            ? $t("params.change_logo")
                            : $t("params.choose_logo")
                        }}</span>
                      </label>
                    </div>

                    <span style="font-size: 13px"
                      >{{ $t("params.click_circle") }}
                      {{
                        schoolLogo ? $t("params.modify") : $t("params.upload")
                      }}
                      {{ $t("params.your_logo") }}</span
                    >
                  </div>

                  <div class="row">
                    <div class="mb-3 col-6 px-8">
                      <h6 style="transform: translateY(13px)" class="fw-bold">
                        {{ $t("params.school_name") }}

                      </h6>
                      <div class="d-flex">
                        <p class="mt-4 w-80">{{ name }}</p>
                        <p
                          class="mt-4 w-10 pt-1 cursor-pointer"
                          data-bs-toggle="modal"
                          data-bs-target="#editSchoolNameModal"
                          @click="openEditNameModal"
                          :title="$t('errors.click_edit_school_name')"
                        >
                          <i class="fa-solid fs-5 fa-pencil"></i>
                        </p>
                      </div>
                      <hr class="mt-3 horizontal" />
                    </div>
                    
                    <div class="mb-3 col-6 px-8" v-if="studentCount">
                      <h6 style="transform: translateY(13px)" class="fw-bold">
                        {{ $t("params.student_count1") }}
                      </h6>
                      <div class="d-flex">
                        <p class="mt-4 w-80">
                          {{
                            Number(studentCount).toLocaleString(
                              this.$i18n.locale === "fr" ? "fr-FR" : "en-US",
                              {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              }
                            )
                          }}
                        </p>
                        <p
                          class="mt-4 w-10 pt-1 cursor-pointer"
                          data-bs-toggle="modal"
                          data-bs-target="#editStudentCountModal"
                          @click="openStudentCountModal"
                          :title="$t('errors.click_edit_student_count')"
                        >
                          <i class="fa-solid fs-5 fa-pencil"></i>
                        </p>
                      </div>
                      <hr class="mt-2 horizontal" />
                    </div>

                    <div class="mb-3 col-6 px-8">
                      <h6 style="transform: translateY(13px)" class="fw-bold">
                        {{ $t("params.education_system") }}
                      </h6>

                      <p class="mt-3">{{ education_system1 }}</p>
                      <hr class="mt-2 horizontal" />
                    </div>

                    <div class="mb-3 col-6 px-8">
                      <h6 style="transform: translateY(13px)" class="fw-bold">
                        {{ $t("params.education_grade") }}
                      </h6>

                      <p class="mt-3">{{ education_grade1 }}</p>
                      <hr class="mt-2 horizontal" />
                    </div>

                    <div class="mb-3 col-6 px-8">
                      <h6 style="transform: translateY(13px)" class="fw-bold">
                        {{ $t("params.training_type") }}
                      </h6>
                      <p class="mt-4">{{ training_type1 }}</p>
                      <hr class="mt-2 horizontal" />
                    </div>

                    <div class="mb-3 col-6 px-8">
                      <h6 style="transform: translateY(13px)" class="fw-bold">
                        {{ $t("params.currency") }}
                      </h6>

                      <p class="mt-4">{{ currency_code }}</p>
                      <hr class="mt-2 horizontal" />
                    </div>

                    <div class="mb-3 col-6 px-8">
                      <h6 style="transform: translateY(13px)" class="fw-bold">
                        {{ $t("params.owner") }}
                      </h6>

                      <p class="mt-4">{{ owner }}</p>
                      <hr class="mt-2 horizontal" />
                    </div>

                    <div class="mb-3 col-6 px-8">
                      <h6 style="transform: translateY(13px)" class="fw-bold">
                        {{ $t("params.region") }}
                      </h6>

                      <p class="mt-4">{{ region }}</p>
                      <hr class="mt-2 horizontal" />
                    </div>
                    <div class="mb-3 col-6 px-8">
                      <h6 style="transform: translateY(13px)" class="fw-bold">
                        {{ $t("params.city") }}
                      </h6>

                      <p class="mt-4">{{ town }}</p>
                      <hr class="mt-2 horizontal" />
                    </div>

                    <div class="mb-3 col-6 px-8">
                      <h6 style="transform: translateY(13px)" class="fw-bold">
                        {{ $t("params.neighbourhood") }}
                      </h6>

                      <p class="mt-4">{{ hood }}</p>
                      <hr class="mt-2 horizontal" />
                    </div>
                  </div>
                </form>

                <div class="text text-center mt-4" v-if="welcome">
                  <p>{{ $t("params.text1") }}</p>
                  <p>
                    {{ $t("params.text2") }}
                    <span
                      ><a
                        title="Cliquer pour contacter Eska"
                        class="link fw-bold"
                        target="_blank"
                        href="#"
                        >Eska</a
                      ></span
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-4" v-if="hasAdmin">
        <div class="card col-xl-10 col-lg-10 col-md-10 mx-auto">
          <div class="card-body">
            <spinner
              class="text-center mt-8 mb-8"
              v-if="loading"
              style="height: 200px"
            >
              <div>
                <span class="mt-4">
                  <Spinner></Spinner>
                </span>
              </div>
            </spinner>
            <div class="title mb-4 mt-n1">
              <h6>{{ $t("configuration.title") }}</h6>
            </div>
            <div class="school-info">
              <div class="row pt-2 pb-5">
                <div class="col-6">
                  <div class="mt-3 d-flex pe-4 w-60 mb-3">
                    <h6>{{ $t("configuration.bearcosts_title") }}</h6>
                    <div
                      class="form-check form-switch ps-0 my-auto"
                      style="margin-left: 100px"
                      v-if="
                        bear_costs === api_config.BEAR_COSTS ||
                        this.verification === false
                      "
                    >
                      <input class="mt-n1 form-check-input" type="checkbox" id="supportFeesCheckbox1"
                        ref="supportFeesCheckbox" @click="handleCheckboxClick"
                      />
                    </div>

                    <div
                      class="form-check form-switch ps-0 my-auto"
                      style="margin-left: 100px"
                      v-else
                    >
                      <input
                        class="mt-n1 form-check-input"
                        type="checkbox"
                        id="supportFeesCheckbox"
                        v-model="isSupportFeesModalVisible"
                      />
                    </div>
                  </div>
                  <p class="mt-2 d-block">
                    {{ $t("configuration.bearcosts_p") }}
                  </p>
                </div>
                <div class="col-6">
                  <div class="mt-3 d-flex w-60 mb-3">
                    <h6>{{ $t("configuration.splitpayment_title") }}</h6>
                    <div class="form-check form-switch ps-0 ms-auto my-auto">
                      <input
                        class="form-check-input mt-n1"
                        type="checkbox"
                        id="smallInstallmentCheckbox"
                        ref="smallInstallmentCheckbox"
                        @click="handleSmallInstallmentCheckboxClick"
                        :checked="shouldCheckboxBeChecked"
                      />
                    </div>
                  </div>
                  <p class="mt-2 d-block">
                    {{ $t("configuration.splitpayment_p") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-4" v-if="hasAdmin" id="payment-settings">
        <div class="card col-xl-10 col-lg-10 col-md-10 mx-auto">
          <div class="card-body">
            <div class="title mb-4 mt-n1">
              <h6>{{ $t("min_transfer.title") }}</h6>
            </div>
            <p class="mt-4 mb-4 d-block">
              {{ $t("min_transfer.description1") }}
              {{ currency_code }}

              {{
                Number(transfer_min_amount).toLocaleString(
                  this.$i18n.locale === "fr" ? "fr-FR" : "en-US",
                  {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  }
                )
              }}
              {{ $t("min_transfer.description2") }}
            </p>

            <div class="amounts-container">
              <div class="row">
                <div class="col-md-8">
                  <div class="d-flex flex-wrap gap-3">
                    <div
                      v-for="amount in transferAmounts"
                      :key="amount"
                      class="form-check"
                    >
                      <input
                        type="radio"
                        class="form-check-input"
                        :id="'amount-' + amount"
                        :value="amount"
                        v-model="selectedAmount"
                        name="transfer-amount"
                      />
                      <label class="form-check-label" :for="'amount-' + amount">
                        {{ currency_code }}

                        {{
                          Number(amount).toLocaleString(
                            this.$i18n.locale === "fr" ? "fr-FR" : "en-US",
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }
                          )
                        }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mt-4">
                <button
                  class="btn btn-success text-white"
                  style="width: 150px"
                  @click="openConfirmModal"
                  data-bs-toggle="modal"
                  data-bs-target="#confirmTransferModal"
                  :disabled="
                    !selectedAmount || selectedAmount === transfer_min_amount
                  "
                >
                  {{ $t("button.save") }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal de confirmation -->
        <div class="modal fade" id="confirmTransferModal" tabindex="-1">
          <div class="modal-dialog ms-auto">
            <div class="card">
              <div class="modal-content">
                <div class="modal-header border-0">
                  <button
                    type="button"
                    class="btn-close"
                    @click="closeModal"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>

                <div class="modal-body text-center">
                  <!-- État en attente -->
                  <div
                    class="modal-body text-center pt-4 pb-4"
                    v-if="
                      claims3.data &&
                      claims3.data.some((claim) => claim.status === 0)
                    "
                  >
                    <i class="bi bi-hourglass-split text-warning fs-2 mb-3"></i>
                    <h6 class="">
                      {{ $t("min_transfer.claim_status_pending") }}
                    </h6>

                    <div class="d-flex justify-content-center mt-3">
                      <div class="me-4 text-center">
                        <small class="d-block text-muted">{{
                          $t("min_transfer.current_value")
                        }}</small>
                        <span class="fw-bold"
                          >{{ currency_code }}
                          {{
                            Number(transfer_min_amount).toLocaleString(
                              this.$i18n.locale === "fr" ? "fr-FR" : "en-US",
                              {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              }
                            )
                          }}</span
                        >
                      </div>
                      <div class="d-flex align-items-center">
                        <i class="bi bi-arrow-right mx-2"></i>
                      </div>
                      <div class="ms-4 text-center">
                        <small class="d-block text-muted">{{
                          $t("min_transfer.new_value")
                        }}</small>
                        <span class="fw-bold"
                          >{{ currency_code }}
                          {{
                            Number(requested_amount).toLocaleString(
                              this.$i18n.locale === "fr" ? "fr-FR" : "en-US",
                              {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              }
                            )
                          }}</span
                        >
                      </div>
                    </div>
                  </div>

                  <!-- État en cours -->
                  <div
                    class="modal-body text-center pt-4 pb-4"
                    v-else-if="
                      claims3.data &&
                      claims3.data.some((claim) => claim.status === 1)
                    "
                  >
                    <i class="bi bi-arrow-repeat text-info fs-1 mb-3"></i>
                    <h6>{{ $t("min_transfer.in_progress_title") }}</h6>

                    <div class="d-flex justify-content-center mt-3">
                      <div class="me-4 text-center">
                        <small class="d-block text-muted">{{
                          $t("min_transfer.current_value")
                        }}</small>
                        <span class="fw-bold"
                          >{{ currency_code }}
                          {{
                            Number(transfer_min_amount).toLocaleString(
                              this.$i18n.locale === "fr" ? "fr-FR" : "en-US",
                              {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              }
                            )
                          }}</span
                        >
                      </div>
                      <div class="d-flex align-items-center">
                        <i class="bi bi-arrow-right text-info mx-2"></i>
                      </div>
                      <div class="ms-4 text-center">
                        <small class="d-block text-muted">{{
                          $t("min_transfer.requested_value")
                        }}</small>
                        <span class="fw-bold text-info"
                          >{{ currency_code }}
                          {{
                            Number(requested_amount).toLocaleString(
                              this.$i18n.locale === "fr" ? "fr-FR" : "en-US",
                              {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              }
                            )
                          }}</span
                        >
                      </div>
                    </div>
                  </div>

                  <!-- État initial - Confirmation -->
                  <div class="modal-body text-center pt-4 pb-4" v-else>
                    <i
                      class="bi bi-exclamation-triangle-fill text-warning fs-2 mb-3"
                    ></i>
                    <h6>{{ $t("min_transfer.title_content") }}</h6>
                    <p class="px-6">
                      {{ $t("min_transfer.description_modal") }}
                      {{ currency_code }}
                      {{
                        Number(selectedAmount).toLocaleString(
                          this.$i18n.locale === "fr" ? "fr-FR" : "en-US",
                          {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                          }
                        )
                      }}
                      ?
                    </p>
                  </div>
                </div>

                <div class="modal-footer border-0 mb-1 pb-5">
                  <template v-if="!hasStatusZeroOrOne">
                    <argon-button
                      type="button"
                      class="btn bg-transparent"
                      @click="closeModal"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      style="
                        width: 150px;
                        height: 50px;
                        padding-top: 15px;
                        border: 1px solid rgba(255, 255, 255, 0.4);
                      "
                    >
                      {{ $t("button.cancel") }}
                    </argon-button>
                    <argon-button
                      :loading="loading"
                      :active="buttonActive || showConfirmation"
                      :clickEvent="button"
                      color="danger"
                      variant="gradient"
                      type="button"
                      class="mt-1"
                      style="width: 150px; height: 50px; padding-top: 15px ; margin-right: 110px;"
                      @click="saveNewAmount"
                    >
                      <span v-if="!loading">{{ $t("button.confirm") }}</span>
                    </argon-button>
                  </template>

                  <argon-button
                    v-else
                    type="button"
                    class="btn bg-transparent"
                    @click="closeModal"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    style="
                      width: 150px;
                      height: 50px;
                      padding-top: 15px;
                      border: 1px solid rgba(255, 255, 255, 0.4);
                      margin-right: 110px;
                    "
                  >
                    {{ $t("button.close") }}
                  </argon-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Include the modals -->
      <div class="container mt-4">
        <div class="card col-xl-10 col-lg-10 col-md-10 mx-auto">
          <div class="card-body">
            <div class="classroom-banner d-flex align-items-center justify-content-between p-3 rounded">
              <div class="banner-text me-3">
                <h6 class="fw-bold mb-1">{{ $t('classroom_setup.title') }}</h6>
                <p class="mb-0 small text-white-75">{{ $t('classroom_setup.description') }}</p>
              </div>
              <div class="banner-action">
                <router-link :to="{ name: 'classroom-setup' }">
                  <button class="btn btn-light btn-sm">{{ $t('classroom_setup.button') }}</button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--
        Modèles de documents de l'établissement — certificat de scolarité et
        reçu de paiement.

        Ils n'arrivent ici qu'une fois configurés. Tant qu'ils ne le sont pas,
        l'invitation à les configurer reste sur les écrans où l'on se sert du
        document (classes, configuration des paiements, impayés) : c'est là
        que le manque se fait sentir. Une fois le modèle enregistré, il n'a
        plus rien à faire au milieu du travail quotidien et rejoint les
        paramètres, sous la configuration du module Classroom.
      -->
      <div
        class="container mt-4"
        v-if="showCertificateBanner || showReceiptBanner"
      >
        <div class="card col-xl-10 col-lg-10 col-md-10 mx-auto">
          <div class="card-body">
            <div class="settings-document-banners">
              <div class="row g-3">
                <div :class="bannerColumnClass" v-if="showCertificateBanner">
                  <certificate-banner settings />
                </div>
                <div :class="bannerColumnClass" v-if="showReceiptBanner">
                  <payment-receipt-banner settings />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SupportFeesModal
        :isVisible="isSupportFeesModalVisible"
        @update:isVisible="updateSupportFeesModalVisibility"
        @close="resetSupportFeesCheckbox"
        @Fees_payments="Fees_payments"
      />
      <SmallInstallmentModal
        :isVisible="!isSmallInstallmentModalVisible"
        @update:isVisible="updateSmallInstallmentModalVisibility"
        @close="resetSmallInstallmentCheckbox"
        @save="saveNewAmount"
      />
    </main>
    <app-footer />
  </div>
</template>

<script>
import api_config from "@/config";
import AppFooter from "@/widget/PageLayout/Footer.vue";
import { getConfig, updateStudentCount, updateSchoolName } from "@/utils/auth";
import SupportFeesModal from "@/views/modal/SupportFeesModal.vue";
import SmallInstallmentModal from "@/views/modal/SmallInstallmentModal.vue";
import ArgonButton from "@/components/ArgonButton";
import NetworkStatus from "@/views/components/NetworkStatus.vue";
import Studentcount from "./modal/Studentcount.vue";
import CertificateBanner from "@/views/Classroom/CertificateBanner.vue";
import PaymentReceiptBanner from "@/views/Classroom/PaymentReceiptBanner.vue";
import {
  isCertificateConfigured,
  isReceiptConfigured,
  loadCertificateFromApi,
  loadReceiptFromApi,
} from "@/utils/classroomSetup";

import "vue3-toastify/dist/index.css";
import {
  getSchoolinfo,
  uploadFileForModel,
  submit_claims_min_transfer,
  getCleams,
} from "@/utils/services";
import Spinner from "../components/Spinner.vue";
import { pullGrades, pullSpecialities } from "@/utils/setup";
import { getMembers, xpayconnection, getsystem_config } from "@/utils/services";
import { ref, onMounted } from "vue";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
const body = document.getElementsByTagName("body")[0];

export default {
  name: "app-config",
  components: {
    AppFooter,
    Spinner,
    SupportFeesModal,
    SmallInstallmentModal,
    ArgonButton,
    NetworkStatus,
    Studentcount,
    CertificateBanner,
    PaymentReceiptBanner,
  },
  data() {
    return {
      button: "",
      buttonActive: false,
      showConfirmation: false,
      schoolInfo: {},
      schoolId: localStorage.getItem("schoolId") || "",
      isOffline: false,
      apiError: false,
      isSupportFeesModalVisible: false,
      isSmallInstallmentModalVisible: true,
      transferAmounts: [],
      confirmModal: null,
      selectedAmount: null,
      transfer_min_amount: "",
      alert_text: true,
      currency_code: api_config.CURRENCY_CODE,
      configId: localStorage.getItem("configID") || "",
      country_code: api_config.COUNTRY_CODE,
      training_type1: "",
      education_system1: "",
      education_grade1: "",
      education_system: "",
      school_id: localStorage.getItem("schoolId") || "",
      test: "",
      welcome: null,
      loading: false,
      name: "",
      loacalisation: "",
      region: "",
      town: "",
      hood: "",
      owner: "",
      Min_transfer_amount: api_config.MIN_TRANSFER_AMOUNT,
      previewImage: null,
      selectedFile: null,
      schoolLogo: null,
      xpay_connection_id: "",
      claims: [],
      claims3: [],
      bear_costs: null,
      checkboxState: true,
      status: "",
      verification: false,
      api_config,
      requested_amount: "",
      editedSchoolName: "",
      studentCount: null,
      editedStudentCount: "",
      eska_api_token: "",
      eska_api_url: "",
      ip_toolbox_api_url: "",
      sf_web_api_url: "",
      sf_web_token: "",
      xpay_api_token: "",
      xpay_api_url: "",
      showStudentCountModal: false,
    };
  },

  async mounted() {
    /*
     * État des modèles de documents : c'est lui qui décide si la bannière
     * s'affiche ici ou sur les écrans de travail. Le cache local peut être en
     * retard sur le serveur, et une bannière absente de cette page n'est pas
     * montée pour aller le demander elle-même.
     *
     * Sans `await` : la valeur est réactive, l'écran se met à jour seul.
     */
    loadCertificateFromApi(this.$i18n.locale);
    loadReceiptFromApi();

    await this.updateOnlineStatus();

    await this.fetchxpayconnection();
    await Promise.all([
      this.fetchgetclaimsMinstransfer(),
      this.fetchgetclaimsbearcosts(),
      this.fetchgetclaimssplitpayment(),
      this.getSystem_config(),
    ]);

    this.$nextTick(() => {
      if (this.$refs.supportFeesCheckbox) {
        this.$refs.supportFeesCheckbox.checked = true;
      }
    });

    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
    this.intervalId = setInterval(this.checkInternetConnection, 1000);

    if (!this.isOffline) {
      this.fetchxpayconnection();
    }
  },
  setup() {
    const members = ref([]);

    const fetchMembers = async () => {
      try {
        const result = await getMembers();

        if (result.status === 200) {
          members.value = result.data;
          localStorage.setItem("members", JSON.stringify(result.data));
        } else {
          //console.error("Erreur lors de la récupération des membres :", result.error);
        }
      } catch (error) {
        //console.error("Erreur inattendue lors de la récupération des membres :", error);
      }
    };

    onMounted(() => {
      fetchMembers();
    });

    return {
      members,
    };
  },

  methods: {
    openStudentCountModal() {
      this.editedStudentCount = this.studentCount || "";
    },

    closeStudentCountModal() {
      this.editedStudentCount = "";
    },

    openEditNameModal() {
      this.editedSchoolName = this.name;
    },

    closeEditNameModal() {
      this.editedSchoolName = "";
    },

    async saveStudentCount() {
      try {
        if (this.loading) {
          return;
        }

        if (!navigator.onLine) {
          const message = this.$t("message.notinternet");
          toast.error(message, {
            autoClose: 3000,
          });
          return;
        }

        this.loading = true;
        this.buttonActive = true;

        console.log("Loading state:", this.loading);

        const response = await updateStudentCount(
          this.configId,
          this.editedStudentCount
        );

        if (response && response.status === 200) {
          this.studentCount = parseInt(this.studentCount, 10);

          const message = this.$t("params.student_count_updated");
          toast.success(message, {
            autoClose: 3000,
          });

          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          const message = this.$t("params.updateFailed");
          toast.error(message, {
            autoClose: 3000,
          });
        }
      } catch (error) {
        console.error(
          "Erreur lors de la mise à jour du nombre d'élèves:",
          error
        );
        toast.error(this.$t("params.updateFailed"), {
          autoClose: 3000,
        });
      } finally {
        setTimeout(() => {
          this.loading = false;
          this.buttonActive = false;
        }, 500);
      }
    },

    async saveSchoolName() {
      try {
        if (this.loading) {
          return;
        }

        if (!navigator.onLine) {
          const message = this.$t("message.notinternet");
          toast.error(message, {
            autoClose: 3000,
          });
          return;
        }
        this.loading = true;
        this.buttonActive = true;

        const response = await updateSchoolName(
          this.configId,
          this.editedSchoolName
        );

        if (response && response.status === 200) {
          this.studentCount = parseInt(this.studentCount, 10);

          const message = this.$t("params.school_name_updated");
          toast.success(message, {
            autoClose: 3000,
          });

          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          const message = this.$t("params.updateFailed");
          toast.error(message, {
            autoClose: 3000,
          });
        }
      } catch (error) {
        console.error(
          "Erreur lors de la mise à jour du nombre d'élèves:",
          error
        );
        toast.error(this.$t("params.updateFailed"), {
          autoClose: 3000,
        });
      } finally {
        setTimeout(() => {
          this.loading = false;
          this.buttonActive = false;
        }, 500);
      }
    },

    getApprovedClaimAmount() {
      if (
        !this.claims3 ||
        !this.claims3.data ||
        !Array.isArray(this.claims3.data)
      ) {
        return 0;
      }

      const approvedClaim = this.claims3.data.find(
        (claim) => claim.status === 2
      );
      if (
        approvedClaim &&
        approvedClaim.data &&
        approvedClaim.data.Min_transfer_amoun
      ) {
        return approvedClaim.data.Min_transfer_amoun;
      }

      return 0;
    },

    getPendingClaimAmount() {
      if (
        !this.claims3 ||
        !this.claims3.data ||
        !Array.isArray(this.claims3.data)
      ) {
        return 0;
      }

      const pendingClaim = this.claims3.data.find(
        (claim) => claim.status === 0
      );
      if (
        pendingClaim &&
        pendingClaim.data &&
        pendingClaim.data.Min_transfer_amoun
      ) {
        return pendingClaim.data.Min_transfer_amoun;
      }

      return 0;
    },

    getInProgressClaimAmount() {
      if (
        !this.claims3 ||
        !this.claims3.data ||
        !Array.isArray(this.claims3.data)
      ) {
        return 0;
      }

      const inProgressClaim = this.claims3.data.find(
        (claim) => claim.status === 1
      );
      if (
        inProgressClaim &&
        inProgressClaim.data &&
        inProgressClaim.data.Min_transfer_amoun
      ) {
        return inProgressClaim.data.Min_transfer_amoun;
      }

      return 0;
    },

    hasClaimForTransaction(operationId) {
      if (
        !this.claims ||
        !this.claims.data ||
        !Array.isArray(this.claims.data)
      ) {
        return false;
      }

      return this.claims.data.some(
        (claim) => claim.data && claim.data.id_operation === operationId
      );
    },

    getClaimStatus(operationId) {
      if (
        !this.claims ||
        !this.claims.data ||
        !Array.isArray(this.claims.data)
      ) {
        return null;
      }

      const claim = this.claims.data.find(
        (claim) => claim.data && claim.data.id_operation === operationId
      );

      return claim ? claim.status : null;
    },

    async updateOnlineStatus() {
      if (navigator.onLine) {
        try {
          await this.checkConnection(this.schoolId);
          this.isOffline = false;
        } catch (error) {
          console.error("Error checking connection:", error);
          this.isOffline = true;
        }
      } else {
        this.isOffline = true;
      }
    },

    onFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedFile = file;

        // Créer une prévisualisation
        const reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result;
          this.schoolLogo = null;
        };
        reader.readAsDataURL(file);

        this.uploadLogo(file);
      }
    },

    closeModal() {
      this.alert_text = true;
    },

    async uploadLogo(file) {
      try {
        this.loading = true;

        const uploadData = {
          file: file,
          model_name: "schooling.schoolconfig",
          media_field: "logo",
          object_id: this.configId,
        };

        const response = await uploadFileForModel(uploadData);

        if (response) {
          console.log("Logo uploaded successfully");
          if (response.path || response.file || response.url) {
            this.schoolLogo = response.path || response.file || response.url;
          }
        }
      } catch (error) {
        console.error("Error uploading logo:", error);
        toast.error(this.$t("params.updateFailed"), { autoClose: 3000 });
      } finally {
        this.loading = false;
      }
    },

    async checkConnection(sf_school_id=this.schoolId) {
      try {
        let reponse = await Promise.all([xpayconnection(sf_school_id)]);

        console.log("Reponse333", reponse);
        this.apiError = false;
      } catch (error) {
        console.error("API Error:", error);
        this.apiError = true;
      }
    },

    async fetchxpayconnection() {
      this.loading = true;
      const sf_school_id = localStorage.getItem("schoolId");

      try {
        this.loading = true;
        let response = await xpayconnection(sf_school_id);

        if (response && response.length > 0) {
          const connection = response[0];
          this.xpay_connection_id = connection.id;
          this.bank_slug = connection.bank_name;
          this.transfer_min_amount = connection.transfer_min_amount;
          this.transaction_number = connection.school_account_number;
          this.selectedAmount = connection.transfer_min_amount;

          if (connection.data && connection.data.min_transfer_options) {
            this.transferAmounts = connection.data.min_transfer_options;
          }

          this.bank_logo = connection.bank_logo;
          this.status_code = connection.status_code;

          localStorage.setItem("xpay_connection_id", this.xpay_connection_id);

          if (this.xpay_connection_id) {
            await this.fetchTransfers();
            await this.fetchXpconnection();
          }
        } else {
          console.error("Invalid response data or empty array:", response);
        }
      } catch (error) {
        console.error("Error during getconnection call:", error);
      } finally {
        this.loading = false;
      }
    },

    async saveNewAmount() {
      if (!this.selectedAmount) return;
      if (this.loading) return;

      try {
        this.loading = true;
        this.buttonActive = true;

        const response = await submit_claims_min_transfer(
          "appConfig",
          api_config.MIN_TRANSFER_AMOUNT_TITLE,
          this.name,
          this.xpay_connection_id,
          this.transfer_min_amount,
          this.selectedAmount
        );

        if (response) {
          const message = this.$t("min_transfer.description_success");
          toast.success(message, {
            autoClose: 3000,
          });

          setTimeout(() => {
            window.location.reload();
            this.transfer_min_amount = this.selectedAmount;
          }, 3000);
        }
      } catch (error) {
        console.error("Erreur lors de la soumission de la réclamation:", error);
      } finally {
        this.loading = false;
        this.buttonActive = false;
      }
    },

    async fetchgetclaimsMinstransfer() {
      const connection_id = this.xpay_connection_id;
      const type = "AppConfig";
      const title = api_config.MIN_TRANSFER_AMOUNT_TITLE;

      try {
        let response = await getCleams(connection_id, type, title);
        this.claims3 = response || [];
        this.requested_amount = this.claims3.data.map(
          (claim) => claim.data.requested_amount
        );
      } catch (error) {
        console.error("Error fetching incorrect amount claims:", error);
      } finally {
        this.loading = false;
      }
    },

    async fetchgetclaimsbearcosts() {
      const connection_id = this.xpay_connection_id;
      const type = "AppConfig";
      const title = api_config.FEES_ON_PAYER_TITLE;

      try {
        let response = await getCleams(connection_id, type, title);
        this.claims = response || [];
        this.bear_costs = this.claims.data.map(
          (claim) => claim.data.bear_costs
        );
        this.status = this.claims.data.map((claim) => claim.status);
        if (this.status === 2) {
          this.verification = true;
        }
      } catch (error) {
        console.error("Error fetching incorrect amount claims:", error);
      } finally {
        this.loading = false;
      }
    },

    async fetchgetclaimssplitpayment() {
      const connection_id = this.xpay_connection_id;
      const type = "AppConfig";
      const title = api_config.ALLOW_SPLIT_PAYMENT_TILTLE;

      try {
        let response = await getCleams(connection_id, type, title);
        this.claims = response || [];
        this.split_payment_status = this.claims.data.map(
          (claim) => claim.status
        );
        if (this.status === 2) {
          this.verification = true;
        }

        if (this.claims.data && this.claims.data.length > 0) {
          const latestClaim = this.claims.data[this.claims.data.length - 1];
          this.bear_costs = latestClaim.data.bear_costs;

          this.isSmallInstallmentModalVisible =
            this.bear_costs !== api_config.NO_SPLIT_PAYEMENT;
        }

        // Mettre à jour verification si le statut est 2 (approuvé)
        if (this.split_payment_status.includes(2)) {
          this.verification = true;
        }
      } catch (error) {
        console.error("Error fetching split payment claims:", error);
      } finally {
        this.loading = false;
      }
    },

    handleSmallInstallmentCheckboxClick(event) {
      event.preventDefault();

      // Inverser l'état du modal
      this.isSmallInstallmentModalVisible =
        !this.isSmallInstallmentModalVisible;

      // Mettre à jour la checkbox
      if (this.$refs.smallInstallmentCheckbox) {
        this.$refs.smallInstallmentCheckbox.checked =
          this.shouldCheckboxBeChecked;
      }
    },

    resetSmallInstallmentCheckbox() {
      // Remettre l'état initial en fonction de bear_costs
      this.isSmallInstallmentModalVisible =
        this.bear_costs !== api_config.NO_SPLIT_PAYEMENT;

      if (this.$refs.smallInstallmentCheckbox) {
        this.$refs.smallInstallmentCheckbox.checked =
          this.shouldCheckboxBeChecked;
      }
    },

    updateSupportFeesModalVisibility(isVisible) {
      this.isSupportFeesModalVisible = !isVisible;
    },

    updateSmallInstallmentModalVisibility(isVisible) {
      this.isSmallInstallmentModalVisible = isVisible;
    },

    toggleSupportFeesModal() {
      this.isSupportFeesModalVisible = !this.isSupportFeesModalVisible;
      this.checkboxState = true;
    },
    handleCheckboxClick(event) {
      event.preventDefault();
      this.$refs.supportFeesCheckbox.checked = true;
      this.isSupportFeesModalVisible = true;
    },

    resetSupportFeesCheckbox() {
      this.isSupportFeesModalVisible = false;

      // S'assurer que la checkbox reste cochée après fermeture du modal
      if (this.$refs.supportFeesCheckbox) {
        this.$refs.supportFeesCheckbox.checked = true;
      }
    },

    updateSchoolId(id) {
      this.school_id = id;
      localStorage.setItem("schoolId", id);
    },

    async getAppConfig() {
      try {
        this.loading = true;
        let data = await getConfig();

        setTimeout(() => {
          if (!navigator.onLine) {
            alert(
              "Vous n'êtes pas connecté à Internet. Veuillez vérifier votre connexion et réessayer."
            );
          }
        }, 30000);
        this.configId = data[0].id;
        localStorage.setItem("configID", this.configId);
        if (!this.training_type1) {
          this.training_type1 = data.training_type;
        }
        if (!this.education_system1) {
          this.education_system1 = data.education_system;
        }
        if (!this.education_grade1) {
          this.education_grade1 = data.education_grade;
        }
        if (!this.school_id) {
          this.school_id = data[0].school_id;
          localStorage.setItem("schoolId", this.school_id);
        }
        if (data[0].logo) {
          this.schoolLogo = data[0].logo;
        }
        if (!this.currency_code) {
          this.currency_code = data[0].currency_code;
        }
        // On récupère le nombre d'élèves
        this.studentCount = data[0].student_count;
        // Afficher la modale seulement si student_count est vide, nul ou 0
        if (!this.studentCount || this.studentCount === 0) {
          this.showStudentCountModal = true;
        } else {
          this.showStudentCountModal = false;
        }
        await this.getSchoolInfo(this.school_id);
        if (this.schoolInfo.length > 0) {
          if (!this.education_grade1) {
            this.education_grade1 = this.schoolInfo[0].education_grade;
          }
          if (!this.education_system1) {
            this.education_system1 = this.schoolInfo[0].education_system;
          }
          if (!this.training_type1) {
            this.training_type1 = this.schoolInfo[0].training_type;
          }
          if (!this.name) {
            this.name = this.schoolInfo[0].name;
          }
          if (!this.region) {
            this.region = this.schoolInfo[0].region;
          }
          if (!this.town) {
            this.town = this.schoolInfo[0].town;
          }
          if (!this.hood) {
            this.hood = this.schoolInfo[0].hood;
          }
          if (!this.owner) {
            this.owner = this.schoolInfo[0].owner;
          }
        }
      } catch (error) {
        console.error(
          "Erreur lors de la récupération de la configuration :",
          error
        );
      } finally {
        this.loading = false;
      }
    },

    watch: {
      training_type1(value) {
        this.training_type = value;
      },
      education_system1(value) {
        this.education_system = value;
      },
      education_grade1(value) {
        this.education_grade = value;
      },
    },

    async getSchoolInfo(schoolId) {
      try {
        const response = await getSchoolinfo(schoolId);

        if (response.status === 200) {
          this.schoolInfo = response.data;
        }
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des informations de l'école :",
          error
        );
      }
    },

    async getSystem_config(isAuthenticated = true) {
      try {
        const response = await getsystem_config(isAuthenticated);

        if (
          response && response.status === 200


        ) {
          // Récupérer les valeurs sans condition
          this.eska_api_token = response.data.eska_api_token;
          localStorage.setItem("eska_api_token", this.eska_api_token);

          this.eska_api_url = response.data.eska_api_url;
          localStorage.setItem("eska_api_url", this.eska_api_url);

          this.ip_toolbox_api_url = response.data.ip_toolbox_api_url;
          localStorage.setItem("ip_toolbox_api_url", this.ip_toolbox_api_url);

          this.sf_web_api_url = response.data.sf_web_api_url;
          localStorage.setItem("sf_web_api_url", this.sf_web_api_url);

          this.xpay_api_token = response.data.xpay_api_token;
          localStorage.setItem("xpay_api_token", this.xpay_api_token);

          this.xpay_api_url = response.data.xpay_api_url;
          localStorage.setItem("xpay_api_url", this.xpay_api_url);
        } else {
          console.error(
            "Données de configuration système invalides ou vides:",
            response
          );
        }
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des configurations système:",
          error
        );
      }
    },

    async saveConfig() {
      this.loading = true;
      this.button = "disabled";

      let grade = await pullGrades();

      if (grade.status !== 200) {
        this.button = "";
        return;
      }

      let specialities = await pullSpecialities();
      if (specialities.status !== 200) {
        this.button = "";
        return;
      }

      if (this.schoolInfo.length > 0) {
        if (!this.education_grade1) {
          this.education_grade1 = this.schoolInfo[0].education_grade;
        }
        if (!this.education_system1) {
          this.education_system1 = this.schoolInfo[0].education_system;
        }
        if (!this.training_type1) {
          this.training_type1 = this.schoolInfo[0].training_type;
        }

        if (!this.name) {
          this.name = this.schoolInfo[0].name;
        }
        if (!this.region) {
          this.region = this.schoolInfo[0].region;
        }
        if (!this.town) {
          this.town = this.schoolInfo[0].town;
        }
        if (!this.hood) {
          this.hood = this.schoolInfo[0].hood;
        }
        if (!this.owner) {
          this.owner = this.schoolInfo[0].owner;
        }
      }

      // type  de paiment
      const payment_type = this.owner === "Private" ? "SchoolFees" : "govFees";
      localStorage.setItem("payment_type", payment_type);
      // Stockage des données dans le localStorage
      localStorage.setItem("training_type", this.training_type1);
      localStorage.setItem("education_grade", this.education_grade1);
      localStorage.setItem("education_system", this.education_system1);
      localStorage.setItem("name", this.name);
      localStorage.setItem("region", this.region);
      localStorage.setItem("town", this.town);
      localStorage.setItem("hood", this.hood);
      localStorage.setItem("owner", this.owner);
      localStorage.setItem("schoolId", this.school_id);

      this.$router.push("/");
      setTimeout(() => {
        this.button = "";
      }, 1000);
    },
  },
  created() {
    this.getAppConfig();
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },

  computed: {
    /*
     * Bannières de documents : l'inverse des écrans de travail. Ici on ne
     * montre que les modèles déjà configurés — le rappel de ce qui a été
     * enregistré, et le chemin pour le modifier.
     */
    showCertificateBanner() {
      return isCertificateConfigured();
    },
    showReceiptBanner() {
      return isReceiptConfigured();
    },
    /* Seule à l'écran, une bannière prend toute la largeur plutôt que de
       laisser la moitié droite vide. */
    bannerColumnClass() {
      return this.showCertificateBanner && this.showReceiptBanner ? "col-lg-6" : "col-12";
    },

    hasStatusZeroOrOne() {
      return (
        this.claims3.data &&
        this.claims3.data.some(
          (claim) => claim.status === 0 || claim.status === 1
        )
      );
    },

    shouldCheckboxBeChecked() {
      return (
        this.bear_costs === api_config.NO_SPLIT_PAYEMENT ||
        (this.claims &&
          this.claims.data &&
          this.claims.data.some(
            (claim) =>
              claim.status === 0 || claim.status === 1 || claim.status === 2
          ))
      );
    },

    hasPendingClaim() {
      return (
        this.claims &&
        this.claims.data &&
        this.claims.data.some((claim) => claim.status === 0)
      );
    },

    hasInProgressClaim() {
      return (
        this.claims &&
        this.claims.data &&
        this.claims.data.some((claim) => claim.status === 1)
      );
    },

    hasApprovedClaim() {
      return (
        this.claims &&
        this.claims.data &&
        this.claims.data.some((claim) => claim.status === 2)
      );
    },

    hasAdmin() {
      return this.members.some((member) => member.is_staff);
    },
  },

  beforeUnmount() {
    this.getAppConfig();
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);

    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
};
</script>

<style>
/*
  Mise en page des deux bannières de documents (certificat, reçu).

  Non scopé volontairement : `.cert-banner` et `.rcp-banner` appartiennent aux
  composants enfants, où un sélecteur scopé du parent n'atteindrait que leur
  élément racine.

  Les deux bannières sont mises à la même hauteur : côte à côte, deux cartes
  de hauteurs différentes donneraient un alignement bancal, l'une étant plus
  bavarde que l'autre. L'espacement vient des gouttières de la grille, pas
  des bannières — d'où la marge basse annulée.
*/
.settings-document-banners [class*="col-"] > div,
.settings-document-banners .cert-banner,
.settings-document-banners .rcp-banner {
  height: 100%;
}

.settings-document-banners .cert-banner,
.settings-document-banners .rcp-banner {
  margin-bottom: 0;
}
</style>

<style scoped>
.classroom-banner {
  background: transparent;
  color: inherit;
}
.classroom-banner .banner-text p {
  color: rgba(0, 0, 0, 0.65);
}
.classroom-banner .btn-light {
  color: #1b1b1b;
}
</style>

<style scoped>
.heart-animation {
  text-align: center;
  padding: 10px 25px;
  color: #fff;
  border: 2px solid white;
  box-shadow: 0 0 0 0 rgb(230, 235, 232);
  animation: battement 2s infinite cubic-bezier(0.66, 0, 0, 1);
  text-decoration: none;
  transition: 0.7s;
  cursor: pointer;
}

.heart-animation i {
  font-size: 30px;
  font-weight: bold;
}

.heart-animation:hover {
  text-align: center;

  color: #fff;

  border: 2px solid rgb(7, 156, 40);
  box-shadow: 0 0 0 0 rgb(28, 226, 107);
  animation: battement 2s infinite cubic-bezier(0.66, 0, 0, 1);
  text-decoration: none;
}

@keyframes battement {
  to {
    box-shadow: 0 0 0 30px rgba(255, 71, 84, 0);
  }
}

.horizontal {
  background-image: linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    white,
    rgba(255, 255, 255, 0)
  ) !important;
  transform: translateX(-40px);
}

.link {
  border-bottom: 1px solid rgba(255, 255, 255, 0.4);
  color: red;
}

.amount-btn {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.4);
  color: white;
  padding: 8px 16px;
  transition: all 0.3s ease;
}

.amount-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.6);
  color: white;
}

.amount-btn.active {
  background: #4f61c4;
  border-color: #4f61c4;
  color: white;
}

.modal-content {
  background: #111c44;
  color: white;
}

.modal-header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.modal-footer {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.gap-3 {
  gap: 1rem;
}

.sweet-popup {
  background: #111c44 !important;
  color: white !important;
}

.swal2-popup {
  background: #111c44 !important;
}

.swal2-title,
.swal2-content {
  color: white !important;
}

.swal2-success-circular-line-left,
.swal2-success-circular-line-right,
.swal2-success-fix {
  background-color: #111c44 !important;
}

.upload-container {
  width: 220px;
  height: 220px;
  position: relative;
}

.file-input {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
}

.upload-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px dashed #41b883;
  background-color: #1a2035;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
  /* Pour s'assurer que l'image reste dans le cercle */
  position: relative;
  /* Pour le positionnement du texte */
}

.upload-label:hover {
  background-color: #2a3045;
}

.upload-label:hover .upload-text {
  opacity: 1;
  transform: translateY(0);
}

.upload-icon {
  font-size: 67px;
  color: #41b883;
  margin-bottom: 10px;
}

.upload-text {
  color: #ffffff;
  font-size: 14px;
  background-color: rgba(0, 0, 0, 0.6);
  padding: 5px 10px;
  border-radius: 4px;
  position: absolute;
  bottom: 10px;
  opacity: 0.7;
  transition: all 0.3s ease;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
</style>
